export enum EXAM_STATUS {
  AVAILABLE = 'A',
  PARTIALLY_AVAILABLE = 'I',
  PROCESSING = 'P',
  READY = 'R'
}
